import { InvoiceStatusEnum } from '@ztechapps/totalmilk-payme.contract'

export const InvoiceStatusConstant = {
  draft: {
    value: InvoiceStatusEnum.Draft,
    color: 'muted',
    index: 1,
    description: 'You are still working on this invoice',
  },
  active: {
    value: InvoiceStatusEnum.Active,
    color: 'warning',
    index: 2,
    description: 'The is ready to be send to your customer',
  },
  sent: {
    value: InvoiceStatusEnum.Sent,
    color: 'info',
    index: 3,
    description: 'The invoice was successfully sent via email to your customer',
  },
  seen: {
    value: InvoiceStatusEnum.Seen,
    color: 'info',
    index: 4,
    description: 'Your customer viewed the invoice that you previously sent',
  },
  overdue: {
    value: InvoiceStatusEnum.Overdue,
    color: 'danger',
    index: 5,
    description: 'The invoice passed the overdue date ',
  },
  partiallyPaid: {
    value: InvoiceStatusEnum.PartiallyPaid,
    color: 'info',
    index: 6,
    description: 'Only portion of the invoice amount was paid',
  },
  paid: {
    value: InvoiceStatusEnum.Paid,
    color: 'success',
    index: 7,
    description: 'The invoice was paid in full',
  },
  inActive: {
    value: InvoiceStatusEnum.InActive,
    color: 'muted',
    index: 8,
    description: "Something wrong with this invoice or you simply don't want it",
  },
}
